<template>
  <div id="userGroupMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>用户分组</el-breadcrumb-item>
          <el-breadcrumb-item v-for="(e,i) in groupLinks"
                              :key="i">{{e}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-tabs v-model="activeName"
             type="border-card"
             @tab-click="handleClick">
      <el-tab-pane label="分组管理"
                   class="group_tab"
                   name="group">
        <el-row>
          <el-form :inline="true"
                   class="demo-form-inline">
            <el-form-item label="分组名称::">
              <el-input placeholder="请输入分组名称"
                        v-model="groupPageSearch.searchKeyWord"
                        class="input-with-select">
                <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="grpQuery">查询</el-button>
            </el-form-item>
            <el-form-item style="float:right">
              <el-button type="primary"
                         size="small"
                         @click="addGroup"
                         v-if="is_edit&&is_hasPer">新增分组</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row style="padding-top: 10px">
          <el-table :data="groupList"
                    border
                    style="width: 100%"
                    @current-change="groupCurrentChange"
                    :index="indexMethod"
                    :highlight-current-row="true"
                    :height="groupListheight">
            <el-table-column type="index"
                             label="序号"
                             align="right"
                             width="50">
            </el-table-column>
            <el-table-column prop="fGrpName"
                             label="分组名称">
            </el-table-column>
            <el-table-column fixed="right"
                             width="240"
                             align="center"
                             label="操作">
              <template slot-scope="scope">
                <div v-if="scope.row.fIsAllCust!='1'">
                  <el-button @click="viewGroup(scope.$index, scope.row)"
                             type="success"
                             style="background-color:#5bc0de;border-color:#5bc0de"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editClientGroup(scope.$index, scope.row)"
                             v-if="is_edit&&is_hasPer">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteGroup(scope.$index, scope.row)"
                             v-if="is_del&&is_hasPer">删除</el-button>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row class="pagination">
          <el-col :span="24">
            <div class="block">
              <span class="demonstration"></span>
              <el-pagination background
                             @size-change="handleSizeChange"
                             :current-page.sync="groupPageSearch.pageNo"
                             @current-change="handlePage"
                             :page-sizes="[10, 20, 50, 100]"
                             layout="total,sizes, prev, pager, next, jumper"
                             :total="groupPageSearch.total"
                             v-if="groupPageSearch.total>0">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 10px">
          <group-per-and-park :grpInfoList="grpInfoList"
                              :grpParkList="grpParkList"
                              :childTableHeight="childTableHeight"></group-per-and-park>
        </el-row>
        <el-row>
          <div class="userGroupEdit">
            <el-dialog :title="titleMap[groupForm.operateFlag]"
                       v-dialogDrag
                       :visible.sync="dialogGroupFormVisible"
                       top="7vh"
                       left="0vh">
              <el-form :model="groupForm"
                       :rules="groupRules"
                       ref="groupForm">
                <el-form-item label="分组名称::"
                              label-width="120px"
                              prop="fGrpName"
                              style="padding-bottom: 10px">
                  <el-input v-model="groupForm.fGrpName"
                            autocomplete="off"
                            :disabled="!groupIsEdit"></el-input>
                </el-form-item>
                <el-tabs type="border-card"
                         style="margin-top: 20px">
                  <el-tab-pane style="width: 100%;height: 371px">
                    <span slot="label"><i class="el-icon-setting"></i> 基本信息</span>
                    <fieldset v-for="(e,i) in persData"
                              :key="i">
                      <legend>{{e.GroupName}}</legend>
                      <el-row class="check-group"
                              v-for="(item) in e.NodeTypeList"
                              :key="item.PersTypeID">
                        <el-col :span="6"
                                align="right"
                                style="padding-right: 20px;">{{item.ModName}}::</el-col>
                        <el-col :span="18">
                          <el-checkbox :disabled="!groupIsEdit"
                                       v-model="item.IsChecked"
                                       @change="persChange($event,item.NodeList)">全选</el-checkbox>
                          <el-checkbox v-for="(node) in item.NodeList"
                                       :label="node.PersName"
                                       :key="node.PersID"
                                       v-model="node.IsChecked"
                                       @change="checkChange($event,item,item.NodeList)"
                                       :disabled="node.Disabled ||!groupIsEdit">
                            {{node.PersName}}
                          </el-checkbox>
                        </el-col>
                      </el-row>
                    </fieldset>
                  </el-tab-pane>
                  <el-tab-pane>
                    <span slot="label"><i class="el-icon-news"></i> 绑定客户</span>
                    <el-row style="padding-bottom: 10px">
                      <el-col :span="10">
                        <el-input placeholder="请输入客户编号或名称"
                                  v-model="bindQueryInput"
                                  class="input-with-select">
                          <el-button slot="append"
                                     icon="el-icon-search"
                                     @click="bindQuery"></el-button>
                        </el-input>
                      </el-col>
                      <el-col :span="4">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input placeholder="请输入客户编号或名称"
                                  v-model="unbindQueryInput"
                                  class="input-with-select">
                          <el-button slot="append"
                                     icon="el-icon-search"
                                     @click="unbindQuery"></el-button>
                        </el-input>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="10">
                        <el-table :data="groupForm.bindCustsUI"
                                  border
                                  height="350px"
                                  style="width: 100%;"
                                  highlight-current-row
                                  @current-change="bindParkChange">
                          <el-table-column type="index"
                                           label="序号"
                                           width="50">
                          </el-table-column>
                          <el-table-column prop="unionName"
                                           label="绑定客户">
                          </el-table-column>
                        </el-table>
                      </el-col>
                      <el-col :span="4"
                              style="text-align: center;">
                        <el-row style="padding-top: 60px">
                          <el-col :span="24">
                            <el-button type="primary"
                                       icon="el-icon-d-arrow-left"
                                       style="width: 100px"
                                       @click="leftAllBtnClick"
                                       v-if="is_bind"
                                       :disabled="!groupIsEdit"></el-button>
                          </el-col>
                        </el-row>
                        <el-row style="padding-top: 20px">
                          <el-col :span="24">
                            <el-button type="primary"
                                       icon="el-icon-caret-left"
                                       style="width: 100px"
                                       @click="leftBtnClick"
                                       :disabled="!groupIsEdit"
                                       v-if="is_bind"></el-button>
                          </el-col>
                        </el-row>
                        <el-row style="padding-top: 20px">
                          <el-col :span="24">
                            <el-button type="primary"
                                       icon="el-icon-caret-right"
                                       style="width: 100px"
                                       @click="rightBtnClick"
                                       :disabled="!groupIsEdit"
                                       v-if="is_bind"></el-button>
                          </el-col>
                        </el-row>
                        <el-row style="padding-top: 20px">
                          <el-col :span="24">
                            <el-button type="primary"
                                       icon="el-icon-d-arrow-right"
                                       style="width: 100px"
                                       @click="rightAllBtnClick"
                                       v-if="is_bind"
                                       :disabled="!groupIsEdit"></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="10">
                        <el-table :data="unbindCustsUI"
                                  border
                                  height="350px"
                                  style="width: 100%;"
                                  highlight-current-row
                                  @current-change="unbindParkChange">
                          <el-table-column type="index"
                                           label="序号"
                                           width="50">
                          </el-table-column>
                          <el-table-column prop="unionName"
                                           label="可选客户">
                          </el-table-column>
                        </el-table>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-form>
              <div slot="footer"
                   class="dialog-footer">
                <el-button type="primary"
                           @click="submitForm('groupForm')"
                           v-if="groupIsEdit">保存</el-button>
                <el-button @click="dialogGroupFormVisible = false">取消</el-button>
              </div>
            </el-dialog>
          </div>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="用户管理"
                   class="user_tab"
                   name="user">

        <el-row>
          <el-form :inline="true"
                   class="user-form-inline">
            <el-form-item label="用户分组::"
                          v-if="is_admin&&groupPageSearch.fGrpID=='1'">
              <el-input placeholder="请输入用户分组"
                        v-model="fUsrGroupName"
                        class="input-with-select"></el-input>
            </el-form-item>
            <el-form-item label="用户编号::">
              <el-input placeholder="请输入用户编号"
                        v-model="fUsrNoQuery"
                        class="input-with-select"></el-input>
            </el-form-item>
            <el-form-item label="用户姓名::">
              <el-input placeholder="请输入用户姓名"
                        v-model="fUsrNameQuery"
                        class="input-with-select"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="usrQuery">查询</el-button>
            </el-form-item>
            <el-form-item style="float:right">
              <el-button type="primary"
                         size="small"
                         @click="addUser"
                         v-if="is_edit&&is_hasPer">新增用户</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <el-row>
            <el-table :data="userList"
                      border
                      style="width: 100%"
                      :height="tableHeight">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexUserMethod">
              </el-table-column>
                <el-table-column width="500" v-if="(is_admin&&groupPageSearch.fGrpID=='1')" :formatter="formatGroup" prop="fGrpID"
                               label="分组路径">
              </el-table-column>
              <!-- <el-table-column v-if="(is_admin&&groupPageSearch.fGrpID=='1')" prop="fPGrpName"
                               label="上级分组名称">
              </el-table-column> -->
              <el-table-column prop="fGrpName"
                               label="分组名称">
              </el-table-column>
              <el-table-column prop="fUsrNo"
                               label="用户编号">
              </el-table-column>
              <el-table-column prop="fUsrName"
                               label="用户姓名">
              </el-table-column>
              <el-table-column prop="fUsrMobile"
                               label="联系电话">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column fixed="right"
                               width="350"
                               align="center"
                               label="操作">
                <template slot-scope="scope">
                  <el-button @click="viewUser(scope.$index, scope.row)"
                             type="success"
                             style="background-color:#5bc0de;border-color:#5bc0de"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="updateUser(scope.$index, scope.row)"
                             v-if="is_edit&&is_hasPer">编辑</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="resetPwd(scope.$index, scope.row)"
                             v-if="is_reset&&is_hasPer">重置密码</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="delUser(scope.$index, scope.row)"
                             v-if="is_del&&is_hasPer">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row class="pagination">
            <el-col :span="24">
              <div class="block">
                <span class="demonstration"></span>
                <el-pagination background
                               @size-change="handleUserSizeChange"
                               :current-page.sync="pageNo"
                               @current-change="handleUserPage"
                               :page-sizes="[10, 20, 50, 100]"
                               layout="total,sizes, prev, pager, next, jumper"
                               :total="total"
                               v-if="total>0">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-row>
        <el-row>
          <div class="userMainEdit">
            <el-dialog :title="titleUserMap[form.operateFlag]"
                       :visible.sync="dialogUserFormVisible"
                       v-dialogDrag
                       top="7vh"
                       left="0vh"
                       width="35%"
                       @close="resetUserForm('form')"
                       @open="openUserFun">
              <el-form :model="form"
                       :rules="rules"
                       label-width="90px"
                       ref="form"
                       class="userForm">
                <el-form-item label="用户编号::"
                              prop="fUsrNo">
                  <el-input v-model="form.fUsrNo"
                            autocomplete="off"
                            :disabled="!isEdit || form.fUsrNo==='rjadmin0001'"></el-input>
                </el-form-item>
                <el-form-item label="密码::"
                              prop="fUsrPwd"
                              v-if="form.operateFlag == 'add'">
                  <el-input :type="passw"
                            v-model="form.fUsrPwd"
                            autocomplete="off"
                            :disabled="form.isUsrEdit || !isEdit">
                    <i slot="suffix"
                       :class="icon"
                       @click="showPass"></i>
                  </el-input>
                </el-form-item>
                <div style="color:red;padding-left:90px;"
                     v-if="form.operateFlag == 'add'">初始密码:{{pwd}}</div>
                <el-form-item label="确认密码::"
                              prop="checkPass"
                              v-if="form.operateFlag == 'add'">
                  <el-input :type="passW"
                            v-model="form.checkPass"
                            autocomplete="off"
                            :disabled="form.isUsrEdit || !isEdit">
                    <i slot="suffix"
                       :class="icons"
                       @click="showPassw"></i>
                  </el-input>
                </el-form-item>
                <el-form-item label="用户姓名::"
                              prop="fUsrName">
                  <el-input v-model="form.fUsrName"
                            autocomplete="off"
                            :disabled="!isEdit"></el-input>
                </el-form-item>
                <el-form-item label="联系电话::">
                  <el-input v-model="form.fUsrMobile"
                            autocomplete="off"
                            :disabled="!isEdit"></el-input>
                </el-form-item>
                <el-form-item label="备注信息::"
                              prop="desc">
                  <el-input type="textarea"
                            v-model="form.fRemark"
                            :disabled="!isEdit"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer"
                   class="dialog-footer"
                   style="padding-top: 10px">
                <el-button type="primary"
                           @click="submitUserForm('form')"
                           v-if="isEdit">保存</el-button>
                <el-button @click="dialogUserFormVisible = false">取消</el-button>
              </div>
            </el-dialog>
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import groupPerAndPark from '../../components/groupPerAndPark'
import * as user from '../../api/user'
export default {
  name: 'UserGroup',
  components: { groupPerAndPark },
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.fUsrPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (this.isLoginValidate) {
        if (!((value || '').length >= 8 && (value || '').length <= 30)) {
          callback(new Error('长度为8到30个字符'))
        }
        if (!/^([a-zA-Z]+[0-9]+[!@#$%^&*]+)|([a-zA-Z]+[!@#$%^&*]+[0-9]+)|([0-9]+[!@#$%^&*]+[a-zA-Z]+)|([0-9]+[a-zA-Z]+[!@#$%^&*]+)|([!@#$%^&*]+[a-zA-Z]+[0-9]+)|([!@#$%^&*]+[0-9]+[a-zA-Z]+)$/.test(value)) {
          callback(new Error('密码必须要包含字母、数字和特殊符号'))
        }
      } else {
        if (!((value || '').length >= 6 && (value || '').length <= 30)) {
          callback(new Error('长度为6到30个字符'))
        }
      }
      callback()
    }
    return {
      activeName: 'group',
      is_hasPer: false,
      is_edit: false,
      is_del: false,
      is_bind: false,
      is_reset: false,
      is_admin: false,
      allChildPers: [],
      allPers: [],
      perGroup: [],
      persData: [],
      groupIsEdit: false,
      groupListheight: 0,
      childTableHeight: 0,
      grpInfoList: [],
      grpParkList: [],
      rightCust: {},
      groupList: [],
      unbindCusts: [],
      defaultCusts: [],
      unbindCustsUI: [],
      unbindQueryInput: '',
      bindQueryInput: '',
      groupForm: {
        fGrpID: '',
        fPGrpID: '',
        fGrpName: '',
        bindCusts: [],
        bindCustsUI: [],
        operateFlag: ''
      },
      passw: 'password',
      passW: 'password',
      icon: 'el-input__icon el-icon-view',
      icons: 'el-input__icon el-icon-view',
      isEdit: false,
      isLoginValidate: false,
      fUsrNoQuery: '',
      fUsrNameQuery: '',
      fUsrGroupName: '',
      pwd: '',
      form: {
        fGrpID: '',
        fLevel: '',
        operateFlag: '',
        fUsrID: '',
        fUsrNo: '',
        fUsrPwd: '666666',
        checkPass: '666666',
        fUsrName: '',
        fUsrMobile: '',
        fRemark: '',
        isUsrEdit: false
      },
      tableHeight: 0,
      rules: {
        fUsrNo: [
          { required: true, message: '请输入用户编号', trigger: 'blur' },
          { min: 6, max: 16, message: '长度为6到16个字符', trigger: 'blur' }
        ],
        fUsrPwd: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { validator: validatePwd, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请再次输入用户密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ],
        fUsrName: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ]
      },
      userList: [],
      dialogUserFormVisible: false,
      formLabelWidth: '120px',
      titleUserMap: {
        add: '新增用户',
        edit: '编辑用户',
        view: '查看用户'
      },
      pageSize: 10,
      pageNo: 1,
      total: 0,
      groupRules: {
        fGrpName: [
          { required: true, message: '请输入组名称(组名不能为空)', trigger: 'blur' },
          { min: 1, max: 59, message: '长度在 1 到 59 个字符', trigger: 'blur' }
        ]
      },
      currentRow: null,
      dialogGroupFormVisible: false,
      titleMap: {
        add: '新增分组',
        edit: '编辑分组',
        view: '查看分组'
      },
      groupPageSearch: {
        fGrpID: '',
        fChildGrpID: '',
        searchKeyWord: '',
        pageSize: 10,
        pageNo: 1,
        total: 0
      }
    }
  },
  computed: {
    ...mapState({
      groupLinks: state => state.user.navNodeList,
      userGroup: state => state.user.userGroup
    })
  },
  methods: {
    ...mapActions([
      'editGroup', 'deleteRootGroup', 'setGroupNode',
      'getParkList', 'getPerAndParkByParent', 'getCurrentUserPers', 'editUser', 'getUserByGroupId', 'deleteUser', 'resetUserPwd'
    ]),
    findIndexArray (data, id, indexArray) {
      let arr = Array.from(indexArray)
      for (let i = 0, len = data.length; i < len; i++) {
        arr.push(data[i].name)
        if (data[i].id === id) {
          return arr
        }
        let children = data[i].children
        if (children && children.length) {
          let result = this.findIndexArray(children, id, arr)
          if (result) return result
        }
        arr.pop()
      }
      return false
    },
    formatGroup (row, column, cellValue, index) {
      return this.findIndexArray(this.userGroup, cellValue, []).join('>')
    },
    handleClick (tab, event) {

    },
    persChange (val, NodeList) {
      if (val) {
        for (let i = 0; i < NodeList.length; i++) {
          if (!NodeList[i].Disabled) {
            NodeList[i].IsChecked = true
          }
        }
      } else {
        for (let i = 0; i < NodeList.length; i++) {
          NodeList[i].IsChecked = false
        }
      }
    },
    checkChange (val, item, NodeList) {
      if (val) {
        if (NodeList.filter(r => r.IsChecked).length === NodeList.filter(r => !r.Disabled).length) {
          item.IsChecked = true
        }
      } else {
        item.IsChecked = false
      }
    },
    grpQuery () {
      this.initData()
    },
    refreshUI () {
      this.grpInfoList = []
      this.grpParkList = []
      if (this.currentRow !== null && typeof (this.currentRow) !== 'undefined') {
        let param = {}
        param.fGrpID = this.currentRow.fGrpID
        this.getPerAndParkByParent(param).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                let list = []
                Object.assign(list, data.Data.pers)
                this.grpInfoList = list
                let parks = []
                Object.assign(parks, data.Data.bindCusts)
                this.grpParkList = parks
              }
            }
          }
        })
      }
    },
    groupCurrentChange (val) {
      if (val !== null && typeof (val) !== 'undefined') {
        this.currentRow = val
      }
    },
    indexMethod (index) {
      return this.groupPageSearch.pageSize * (this.groupPageSearch.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.groupPageSearch.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.groupPageSearch.pageNo = index
      this.initData()
    },
    initData () {
      // console.log(this.$route.query.fGrpID)
      this.groupPageSearch.fGrpID = this.$route.query.fGrpID
      this.groupPageSearch.fChildGrpID = this.$route.query.fChildGrpID
      this.groupList = []
      this.currentRow = undefined
      user.getGroupByNode(this.groupPageSearch).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.is_hasPer = data.Data.isHasPer
              this.groupPageSearch.total = data.Data.data.total
              this.groupList = data.Data.data.rows || []
              if (this.groupList && this.groupList.length > 0) {
                this.currentRow = this.groupList[0]
              }
            }
          }
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var pers = []
          for (let i = 0; i < this.persData.length; i++) {
            for (let j = 0; j < this.persData[i].NodeTypeList.length; j++) {
              var checkedNodes = this.persData[i].NodeTypeList[j].NodeList.filter(r => r.IsChecked)
              for (let k = 0; k < checkedNodes.length; k++) {
                pers.push(checkedNodes[k].PersID)
              }
            }
          }
          user.saveGroup({ operateFlag: this.groupForm.operateFlag, fGrpID: this.groupForm.fGrpID, fGrpName: this.groupForm.fGrpName, bindCusts: this.groupForm.bindCusts, pers: pers }).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogGroupFormVisible = false
                this.initData()
                this.$message.success('保存用户组成功')
                if (this.groupForm.operateFlag === 'add') {
                  this.EventBus.$emit('add', { id: data.Data, name: this.groupForm.fGrpName, parentId: this.groupForm.fGrpID, children: [] })
                } else {
                  this.EventBus.$emit('edit', { id: this.groupForm.fGrpID, name: this.groupForm.fGrpName, parentId: this.groupForm.fPGrpID })
                }
                // this.getUserGroupData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    bindQuery () {
      let tmp = this.bindQueryInput.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.groupForm.bindCustsUI = this.copyArr(this.groupForm.bindCusts)
        return
      }
      this.groupForm.bindCustsUI = this.groupForm.bindCusts.filter(r => r.unionName.toLowerCase().indexOf(tmp) > -1)
    },
    unbindQuery () {
      let tmp = this.unbindQueryInput.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.unbindCustsUI = this.copyArr(this.unbindCusts)
        return
      }
      this.unbindCustsUI = this.unbindCusts.filter(r => { return r.unionName.toLowerCase().indexOf(tmp) > -1 })
    },
    copyArr (arr) { // 深层copy
      let res = []
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i])
      }
      return res
    },
    leftAllBtnClick () {
      // this.unbindCusts = []
      for (let i = 0; i < this.unbindCustsUI.length; i++) {
        this.unbindCusts.splice(this.unbindCusts.indexOf(this.unbindCustsUI[i]), 1)
        if (this.groupForm.bindCusts.indexOf(this.unbindCustsUI[i]) === -1) {
          this.groupForm.bindCusts.push(this.unbindCustsUI[i])
        }
      }
      // this.groupForm.bindCusts = this.copyArr(this.groupForm.bindCusts)
      this.groupForm.bindCustsUI = this.copyArr(this.groupForm.bindCusts)
      this.unbindCustsUI = []
    },
    leftBtnClick () {
      if (!this.rightCust || !this.rightCust.fCustID) {
        return
      }
      this.groupForm.bindCustsUI.push(this.rightCust)
      this.groupForm.bindCusts.push(this.rightCust)
      this.unbindCustsUI.splice(this.unbindCustsUI.indexOf(this.rightCust), 1)
      this.unbindCusts.splice(this.unbindCusts.indexOf(this.rightCust), 1)
    },
    rightBtnClick () {
      if (!this.leftCust || !this.leftCust.fCustID) {
        return
      }
      this.unbindCustsUI.push(this.leftCust)
      this.unbindCusts.push(this.leftCust)
      this.groupForm.bindCustsUI.splice(this.groupForm.bindCustsUI.indexOf(this.leftCust), 1)
      this.groupForm.bindCusts.splice(this.groupForm.bindCusts.indexOf(this.leftCust), 1)
    },
    rightAllBtnClick () {
      // this.groupForm.bindCusts = []
      // this.groupForm.bindCustsUI = []
      for (let i = 0; i < this.groupForm.bindCustsUI.length; i++) {
        this.groupForm.bindCusts.splice(this.groupForm.bindCusts.indexOf(this.groupForm.bindCustsUI[i]), 1)
        if (this.unbindCusts.indexOf(this.groupForm.bindCustsUI[i]) === -1) {
          this.unbindCusts.push(this.groupForm.bindCustsUI[i])
        }
      }
      // this.unbindCusts = this.copyArr(this.defaultCusts)
      this.unbindCustsUI = this.copyArr(this.unbindCusts)
      this.groupForm.bindCustsUI = []
    },
    unbindParkChange (cust) {
      this.rightCust = cust
    },
    bindParkChange (cust) {
      this.leftCust = cust
    },
    groupAction () {
      this.dialogGroupFormVisible = true
    },
    openFun (formName) {
      this.$nextTick(() => {
        if (this.$refs[formName]) {
          this.$refs[formName].resetFields()
        }
      })
    },
    addGroup () {
      if (this.$refs['groupForm']) {
        this.$refs['groupForm'].resetFields()
      }
      this.groupIsEdit = true
      this.groupForm.operateFlag = 'add'
      this.groupForm.fGrpName = ''
      this.groupForm.fGrpID = this.$route.query.fGrpID
      this.initPerAndCust({ fGrpID: this.$route.query.fGrpID, fIsAdd: true })
    },
    initPerAndCust (param) {
      this.persData = []
      user.getPermission({ fGrpID: param.fGrpID, fIsAdd: param.fIsAdd }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.persData = data.Data || []
            }
          }
        }
      })
      this.unbindCusts = []
      this.unbindCustsUI = []
      this.groupForm.bindCusts = []
      this.groupForm.bindCustsUI = []
      this.defaultCusts = []
      user.getGroupCust({ fGrpID: param.fGrpID, fIsAdd: param.fIsAdd }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.unbindCusts = data.Data.optionalCustList || []
              this.unbindCustsUI = this.copyArr(this.unbindCusts)
              this.groupForm.bindCusts = data.Data.bindCustList || []
              this.groupForm.bindCustsUI = this.copyArr(this.groupForm.bindCusts)
              this.defaultCusts = this.unbindCusts.concat(this.groupForm.bindCusts)
            }
          }
        }
      })
      this.dialogGroupFormVisible = true
    },
    updateGroup (index, info) {
      if (this.$refs['groupForm']) {
        this.$refs['groupForm'].resetFields()
      }
      Object.assign(this.groupForm, info)
      this.initPerAndCust({ fGrpID: info.fGrpID, fIsAdd: false })
    },
    viewGroup (index, info) {
      this.groupIsEdit = false
      this.groupForm.operateFlag = 'view'
      this.updateGroup(index, info)
    },
    editClientGroup (index, info) {
      this.groupIsEdit = true
      this.groupForm.operateFlag = 'edit'
      this.updateGroup(index, info)
    },
    deleteGroup (index, info) {
      this.$confirm('删除该用户分组【' + info.fGrpName + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        user.deleteUserGroup(info.fGrpID).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.initData()
              this.$message.success('删除用户组成功')
              this.EventBus.$emit('remove', { id: info.fGrpID, name: info.fGrpName, parentId: info.fPGrpID })
              // this.getUserGroupData()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      })
    },
    usrQuery () {
      this.initUserData()
    },
    showPass () {
      let passw = this.passw
      if (passw === 'text') {
        this.passw = 'password'
        this.icon = 'el-input__icon el-icon-view'
      } else {
        this.passw = 'text'
        this.icon = 'el-input__icon el-icon-loading'
      }
    },
    showPassw () {
      let passW = this.passW
      if (passW === 'text') {
        this.passW = 'password'
        this.icons = 'el-input__icon el-icon-view'
      } else {
        this.passW = 'text'
        this.icons = 'el-input__icon el-icon-loading'
      }
    },
    indexUserMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    openUserFun (formName, type) {
      this.$nextTick(() => {
        if (this.$refs[formName]) {
          this.$refs[formName].resetFields()
        }
        this.setDefaultValue()
        this.dialogUserFormVisible = true
      })
    },
    initUserData () {
      this.form.fGrpID = this.$route.query.fGrpID
      this.form.fLevel = this.$route.query.fLevel
      let param = {}
      param.fGrpID = this.form.fGrpID
      param.pageSize = this.pageSize
      param.pageNo = this.pageNo
      param.fUsrNo = this.fUsrNoQuery
      param.fUsrName = this.fUsrNameQuery
      param.fUsrGroupName = this.fUsrGroupName
      this.getUserByGroupId(param).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let list = []
              Object.assign(list, data.Data.rows)
              this.userList = list
              this.total = data.Data.total
            }
          }
        }
      })
    },
    handleUserSizeChange (value) {
      this.pageSize = value
      this.initUserData()
    },
    handleUserPage (index) {
      this.pageNo = index
      this.initUserData()
    },
    setDefaultValue () {
      this.form.fUsrID = ''
      this.form.fUsrNo = ''
      this.form.fUsrPwd = this.pwd
      this.form.checkPass = this.pwd
      this.form.fUsrName = ''
      this.form.fUsrMobile = ''
      this.form.fRemark = ''
    },
    addUser () {
      this.isEdit = true
      this.form.isUsrEdit = false
      this.form.operateFlag = 'add'
      // this.openFun('form', 'add')
      this.setDefaultValue()
      this.dialogUserFormVisible = true
    },
    viewUser (index, info) {
      this.isEdit = false
      this.form.isUsrEdit = true
      this.form.operateFlag = 'view'
      this.openUserFun('form', 'view')
      user.getUserInfo(info.fUsrID).then(res => {
        if (res && res.data) {
          let { data } = res
          if (data.IsOk) {
            Object.assign(this.form, data.Data)
          }
        }
      })
    },
    updateUser (index, info) {
      this.isEdit = true
      this.form.isUsrEdit = true
      this.form.operateFlag = 'edit'
      this.openUserFun('form', 'edit')
      user.getUserInfo(info.fUsrID).then(res => {
        if (res && res.data) {
          let { data } = res
          if (data.IsOk) {
            Object.assign(this.form, data.Data)
          }
        }
      })
    },
    resetPwd (index, info) {
      this.$confirm('确认重置该用户[' + info.fUsrName + ']密码为初始密码:' + this.pwd + ', 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.resetUserPwd(info.fUsrID).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: '重置成功!'
                })
              }
            }
          }
        })
      }).catch(() => { })
    },
    delUser (index, info) {
      let fUsrNo = info.fUsrNo
      if (fUsrNo === 'rjadmin0001') {
        this.$alert('管理员不能删除', '删除用户', {
          confirmButtonText: '确定'
        })
        return
      }
      let param = {}
      param['fUsrID'] = info.fUsrID
      this.$confirm('此操作将永久删除该用户[' + info.fUsrName + '], 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.deleteUser(param).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.pageNo = 1
                this.initUserData()
              }
            }
          }
        })
      }).catch(() => { })
    },
    submitUserForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editUser(this.form).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status !== 200) {
                this.$message({
                  type: 'error',
                  message: '用户操作出错'
                })
              } else {
                if (!data.IsOk) {
                  this.$message.error(data.Msg)
                } else {
                  this.initUserData()
                  this.$message({
                    type: 'success',
                    message: '用户保存成功'
                  })
                  this.dialogUserFormVisible = false
                }
              }
            }
          })
        }
      })
    },
    resetUserForm (formName) {
      this.$refs[formName].resetFields()
      this.passw = 'password'
      this.icon = 'el-input__icon el-icon-view'
      this.passW = 'password'
      this.icons = 'el-input__icon el-icon-view'
    },
    init () {
      this.initData()
      this.initUserData()
    }
  },
  created () {
    user.initConfig().then((res) => {
      let { data } = res
      if (data.IsOk) {
        this.isLoginValidate = data.Data.validate
        this.pwd = data.Data.pwd
      }
    })
    this.getCurrentUserPers({ perTypeId: 10000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_bind = data.Data.data.is_bind
            this.is_reset = data.Data.data.is_reset
            this.is_admin = data.Data.is_admin
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  watch: {
    '$route': 'init',
    currentRow: function (val) {
      this.refreshUI(val)
    }
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      let clientHeight = sizethis.getRJPageSize.getRJPageSize()[3] - 25 - 230
      sizethis.groupListheight = (clientHeight / 3)
      sizethis.childTableHeight = (clientHeight / 3) * 2
      sizethis.tableHeight = sizethis.getRJPageSize.getRJPageSize()[3] - 280
    }
    this.init()
  },
  updated () {
    let clientHeight = this.getRJPageSize.getRJPageSize()[3] - 25 - 290
    this.groupListheight = (clientHeight / 3)
    this.childTableHeight = (clientHeight / 3) * 2
    this.tableHeight = this.getRJPageSize.getRJPageSize()[3] - 280
  }
}
</script>
<style>
#userGroupMain .el-input.is-disabled .el-input__inner,
#userGroupMain .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#userGroupMain .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
#userGroupMain
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
#userGroupMain .el-checkbox {
  padding-bottom: 5px;
}
#userGroupMain .check-group {
  padding-bottom: 10px;
}

#userGroupMain fieldset {
  border: 1px solid #ccc;
}
#userGroupMain fieldset .check-group:last-child {
  padding-bottom: 0px;
}
.userGroupEdit .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.userGroupEdit .el-dialog__title {
  color: white;
}
.userGroupEdit .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.userGroupEdit .el-dialog__body {
  padding-top: 20px;
  padding-left: 20px;
  padding-left: 20px;
  padding-bottom: 0px;
}
#userGroupMain .userGroupEdit .el-tabs__content {
  height: 400px;
  overflow: auto;
}
.userMainEdit .el-dialog__title {
  color: white;
}
.userMainEdit .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.userMainEdit .el-dialog__body {
  padding-top: 20px;
  padding-left: 20px;
  padding-left: 20px;
  padding-bottom: 0px;
}
.userMainEdit .el-input.is-disabled .el-input__inner,
.userMainEdit .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
</style>
<style scoped>
.group_tab .el-form-item {
  margin-bottom: 0px !important;
}
.user_tab .user-form-inline .el-form-item {
  margin-bottom: 10px !important;
}
.userForm {
  max-width: 500px;
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/view/user/userGroup.vue